module.exports = __webpack_public_path__ + "media/product/t-9-119b835b.png";